import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle `
    body {
        background: #8fbaa3;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: auto;
    }; 
    h1 {

   };
`

export default GlobalStyle;